import type { TranslationKeyListener } from '../types';

let trackingEnabled = false;
const trackedKeys = new Set<string>();
const listeners = new Set<TranslationKeyListener>();

export function enableTracking(): void {
  trackingEnabled = true;
}

export function disableTracking(): void {
  trackingEnabled = false;
}

export function isTrackingEnabled(): boolean {
  return trackingEnabled;
}

function notifyListeners(): void {
  const keysCopy = new Set(trackedKeys);
  // Defer to a microtask: tracking is triggered by t() calls during render,
  // and notifying synchronously would setState in the provider mid-render
  // ("Cannot update a component while rendering a different component").
  queueMicrotask(() => {
    listeners.forEach((listener) => listener(keysCopy));
  });
}

export function trackTranslationKey(key: string): void {
  if (!trackingEnabled) return;

  const hadKey = trackedKeys.has(key);
  if (!hadKey) {
    trackedKeys.add(key);
    notifyListeners();
  }
}

export function getTrackedKeys(): Set<string> {
  return new Set(trackedKeys);
}

export function clearTrackedKeys(): void {
  trackedKeys.clear();
  notifyListeners();
}

export function subscribeToTrackedKeys(listener: TranslationKeyListener): () => void {
  listeners.add(listener);
  // Immediately call with current state
  listener(new Set(trackedKeys));

  return () => {
    listeners.delete(listener);
  };
}
